import {LogProps} from 'modules/logs/types';
import logsKeys from 'modules/logs/util/logs-keys';
import React from 'react';
import List from 'shared/layout/list';
import useProjection from 'shared/migration-hooks/use-projection';

const Logs: React.FC = () => {
  const projection = useProjection<LogProps>('logs', [
    'userId',
    'url',
    'method',
    'statusCode',
    'duration',
    'createdAt',
  ]);

  return (
    <List<LogProps>
      {...{
        titleBar: {
          title: 'Logs',
        },
        table: {
          url: '/logs',
          projection: {
            ...projection,
            options: [
              'userId',
              'url',
              'method',
              'statusCode',
              'duration',
              'createdAt',
            ],
          },
          translatedPropsKey: 'LogProps',
        },
        queryKey: logsKeys.list(),
      }}
    />
  );
};

export default Logs;
